// src/services/influencersApi.js
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "services/api";
import { User } from "../user/types";
import { InfluencerType } from "./types";

export const influencersApi = createApi({
  reducerPath: "influencersService",
  baseQuery,
  endpoints: (builder) => ({
    getInfluencerType: builder.query<InfluencerType[], null>({
      query: () => "/user/influencer-types",
    }),
    getAllInfluencers: builder.query<User[], number>({
      query: (region_id: number) =>
        `/user/influencer/all?region_id=${region_id}`,
    }),
  }),
});

export const { useGetInfluencerTypeQuery, useGetAllInfluencersQuery } =
  influencersApi;
